<div *ngIf="isOpen()" class="sidenav-backdrop" (click)="closeSidenav()"></div>
<div [ngStyle]="{ display: isOpen() || isOpenAnimation() ? 'block' : 'none' }" class="sidenav-menu" [ngClass]="{ open: isOpenAnimation() }">
  <mat-toolbar class="toolbar-sidenav">
    <ng-container *ngIf="mostrarLogo">
      <img class="img-logo-menu" alt="logo" [src]="configBloque?.imgLogoMenu" routerLink="/" width="100%" height="100%" loading="lazy" />
    </ng-container>
    <!-- <mat-icon class="btn-cerrar" (click)="closeSidenav()">close</mat-icon> -->
    <div class="close-icon" (click)="closeSidenav()">
      <app-icon-close [color]="'#fff'"></app-icon-close>
    </div>
  </mat-toolbar>
  <ng-container *ngIf="videosDirecto.length > 0">
    <div class="videos-directo">
      <div>
        <span>Directo</span>
        <span title="Ahora en directo" class="animated"><mat-icon>videocam</mat-icon></span>
      </div>
      <ng-container *ngFor="let item of videosDirecto; trackBy: trackByVideo">
        <div class="video-directo">
          <img src="{{ item?.urlGenerica }}" alt="news" (click)="closeSidenav()" [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]" loading="lazy" width="100%" height="100%" />
        </div>
      </ng-container>
    </div>
  </ng-container>
  <mat-accordion class="menu-acordeon" [multi]="true">
    <ng-container *ngIf="publicidadSidebarMobile?.enlace">
      <div class="sidebar-publicidad-mobile">
        <a [href]="publicidadSidebarMobile?.enlace"><img [src]="publicidadSidebarMobile?.img" alt="publicidad" width="100%" height="100%" loading="lazy" /></a>
      </div>
    </ng-container>
    <!-- @if (mostrarTiempo) {
      <div>
    <app-widget-tiempo class="tiempo-sidemenu"></app-widget-tiempo>
  </div>
    } -->

    <ng-container *ngIf="mostrarRedes">
      <div class="socials-container">
        <ng-container *ngIf="redes?.facebook">
          <a [href]="redes?.facebook" target="_blank"
            ><h4 class="item"><mat-icon>facebook</mat-icon></h4></a
          >
        </ng-container>

        <ng-container *ngIf="redes?.twitter">
          <a [href]="redes?.twitter" target="_blank"
            ><h4 class="item"><img class="icon" alt="twitter" src="assets/images/x.svg" loading="lazy" width="100%" height="100%" /></h4
          ></a>
        </ng-container>

        <ng-container *ngIf="redes?.yt">
          <a [href]="redes?.yt" target="_blank"
            ><h4 class="item"><img class="icon" alt="youtube" src="assets/images/yt-icon.svg" loading="lazy" width="100%" height="100%" /></h4
          ></a>
        </ng-container>

        <ng-container *ngIf="redes?.insta">
          <a [href]="redes?.insta" target="_blank"
            ><h4 class="item"><img class="icon" alt="instagram" src="assets/images/insta-icon.svg" loading="lazy" width="100%" height="100%" /></h4
          ></a>
        </ng-container>

        <ng-container *ngIf="redes?.telegram">
          <a [href]="redes?.telegram" target="_blank"
            ><h4 class="item"><img class="icon" alt="telegram" src="assets/images/telegram-icon.svg" loading="lazy" width="100%" height="100%" /></h4
          ></a>
        </ng-container>
      </div>
    </ng-container>

    <ng-container *ngIf="mostrarSecciones">
      <mat-expansion-panel [expanded]="true" class="container-secciones">
        <mat-expansion-panel-header class="container-expansion-secciones">
          <mat-panel-title> Secciones </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="contenedor-menu-items">
          <ng-container *ngFor="let canal of subcanales; trackBy: trackBySubcanales">
            <a class="item-menu" (click)="closeSidenav()" [routerLink]="['/seccion', canal.idSubcanal, canal.nombreSubCanal | kebabCase]">{{ canal.nombreSubCanal }}</a>
          </ng-container>
          <ng-container *ngIf="mostrarBlogs">
            <a class="item-menu" (click)="closeSidenav()" [routerLink]="['blogs']"> Blogs </a>
          </ng-container>
          <ng-container *ngIf="mostrarRevista">
            <a class="item-menu" (click)="closeSidenav()" [routerLink]="['revistas', 'list_all']">
              {{ configBloque?.nombreRevista }}
            </a>
          </ng-container>
          <ng-container *ngIf="mostrarTienda">
            <a class="item-menu shop" [href]="configBloque.urlTienda" target="_blank">
              {{ configBloque.nombreTienda }}
            </a>
          </ng-container>

          <ng-container *ngIf="!isWebView && subenlaces">
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunaavila.com" target="_blank"><mat-icon class="icon avila">square</mat-icon>Ávila</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunaburgos.com" target="_blank"><mat-icon class="icon burgos">square</mat-icon>Burgos</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunaleon.com" target="_blank"><mat-icon class="icon leon">square</mat-icon>León</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunapalencia.com" target="_blank"><mat-icon class="icon palencia">square</mat-icon>Palencia</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunasalamanca.com" target="_blank"><mat-icon class="icon salamanca">square</mat-icon>Salamanca</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunasegovia.com" target="_blank"><mat-icon class="icon segovia">square</mat-icon>Segovia</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunasoria.com" target="_blank"><mat-icon class="icon soria">square</mat-icon>Soria</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunavalladolid.com" target="_blank"><mat-icon class="icon valladolid">square</mat-icon>Valladolid</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunazamora.com" target="_blank"><mat-icon class="icon zamora">square</mat-icon>Zamora</a>
            <a class="item-menu sub_enlaces_tribuna" href="https://www.tribunamadrid.com" target="_blank"><mat-icon class="icon madrid">square</mat-icon>Madrid</a>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </ng-container>

    <ng-container *ngIf="showApps">
      <mat-accordion id="logos-apps" class="menu-acordeon">
        <div>
          <!--      <img src="assets/images/appletv.webp" width="100%">-->
          <!--      <img src="assets/images/androidtv.webp" width="100%">-->
          <ng-container *ngIf="showAppIos">
            <a href="{{ urlAppIos }}" target="_blank">
              <img [src]="imagenAppIos" alt="app ios" width="100%" height="100%" loading="lazy" />
            </a>
          </ng-container>
          <ng-container *ngIf="showAppAndroid">
            <a href="{{ urlAppAndroid }}" target="_blank">
              <img [src]="imagenAppAndroid" alt="app android" width="100%" height="100%" loading="lazy" />
            </a>
          </ng-container>
          <!--      <img src="assets/images/chromecast.webp" width="100%">-->
          <!--      <img src="assets/images/firetv.webp" width="100%">-->
          <!--      <img src="assets/images/samsung.webp" width="100%">-->
          <!--      <img src="assets/images/webos.webp" width="100%">-->
          <!--      <img src="assets/images/tizen.webp" width="100%">-->
        </div>
      </mat-accordion>
    </ng-container>

    <ng-container *ngIf="mostrarMasVisto">
      <mat-expansion-panel [expanded]="true" class="container-masVisto">
        <mat-expansion-panel-header>
          <mat-panel-title> Lo más visto </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="contenedor-menu-items">
          <ng-container *ngFor="let item of videosMasVisto | slice: 0 : 7; trackBy: trackByVideo">
            <a class="item-menu" (click)="closeSidenav()" [routerLink]="['/noticias', item?.idVideo, item?.tituloSeo | kebabCase]">{{ item?.tituloVideo }}</a>
          </ng-container>
        </div>
      </mat-expansion-panel>
    </ng-container>

    <ng-container *ngIf="publicidadSidebar?.enlace">
      <div class="sidebar-publicidad">
        <a [href]="publicidadSidebar?.enlace"><img [src]="publicidadSidebar?.img" alt="publicidad" loading="lazy" width="100%" height="100%" /></a>
      </div>
    </ng-container>
  </mat-accordion>
</div>
